import React from 'react';

import { ISearchResultsControllerProps } from '../../platform/searchResultsControllerStore';
import { Widget } from '../Widget';
import {
  AppSettingsContext,
  HostContext,
  SearchEnvironmentContext,
} from '../../contexts';
import { useHighlightStyle } from './useHighlightStyle';
import { IHostProps } from '@wix/yoshi-flow-editor';

export interface IWidgetRootProps extends ISearchResultsControllerProps {
  id: string;
  host: IHostProps;
}

export const WidgetRoot: React.FC<IWidgetRootProps> = React.memo((props) => {
  console.log('WidgetRoot:render', props); // eslint-disable-line

  const {
    apiErrorDetails,
    id,
    isDemoContent,
    locale,
    locationQuery,
    currency,
    onDocumentClick,
    onDocumentTypeChange,
    onPageChange,
    onProductAddToCart,
    onFacetsFilterChange,
    onFacetsFilterReset,
    onQuerySubmit,
    onSortChange,
    onScrollToWidget,
    visibleDocumentTypes,
    scrollToWidget,
    searchSamples,
    searchRequest,
    searchRequestStatus,
    searchResponse,
    searchResponseTotals,
    searchResultsAbsoluteUrl,
    selectedSortOption,
    appSettings,
    viewMode,
    host,
    facets,
    facetFilters,
  } = useHighlightStyle(props);

  return (
    <div className={id}>
      <AppSettingsContext.Provider value={appSettings}>
        <SearchEnvironmentContext.Provider
          value={{
            isDemoContent,
            viewMode,
            locale,
            currency,
          }}
        >
          <HostContext.Provider value={host}>
            <Widget
              apiErrorDetails={apiErrorDetails}
              visibleDocumentTypes={visibleDocumentTypes}
              locationQuery={locationQuery}
              onProductAddToCart={onProductAddToCart}
              onDocumentClick={onDocumentClick}
              onDocumentTypeChange={onDocumentTypeChange}
              onFacetsFilterChange={onFacetsFilterChange}
              onFacetsFilterReset={onFacetsFilterReset}
              onPageChange={onPageChange}
              onSortChange={onSortChange}
              onQuerySubmit={onQuerySubmit}
              searchRequest={searchRequest}
              searchRequestStatus={searchRequestStatus}
              searchResponse={searchResponse}
              searchResponseTotals={searchResponseTotals}
              searchResultsAbsoluteUrl={searchResultsAbsoluteUrl}
              searchSamples={searchSamples}
              selectedSortOption={selectedSortOption}
              scrollToWidget={scrollToWidget}
              onScrollToWidget={onScrollToWidget}
              facets={facets}
              facetFilters={facetFilters}
            />
          </HostContext.Provider>
        </SearchEnvironmentContext.Provider>
      </AppSettingsContext.Provider>
    </div>
  );
});
